import React from "react";
import ArtworkPreviewIndex from "../components/artwork-preview";

export default function ArtworkPreview() {
  return <ArtworkPreviewIndex />;
}
